import Vue from 'vue'
import VueRouter from 'vue-router'
import ComingSoon from '../pages/ComingSoon'
import LandingPage from "../pages/LandingPage";
import OurClientsPage from "../pages/OurClientsPage";

Vue.use(VueRouter);

const routes = [
  {
    path: '/coming-soon',
    name: 'ComingSoon',
    component: ComingSoon
  },
  {
    path: '/',
    name: 'LandingPage',
    component: LandingPage
  },
  {
    path: '/our-clients',
    name: 'OurClients',
    component: OurClientsPage
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
